import {
  LIST_EXPORT_DATA_REQUEST,
  LIST_EXPORT_DATA_SUCCESS,
  LIST_EXPORT_DATA_FAIL,
  LIST_EXPORT_DATA_RESET,
  DOWNLOAD_EXPORT_DATA_REQUEST,
  DOWNLOAD_EXPORT_DATA_SUCCESS,
  DOWNLOAD_EXPORT_DATA_FAIL
} from '../../../constants/exports/export-data'

const initialState = {
  loading: false,
  loadingExportDataDownload: false,
  loadingExportDataExport: false,
  exportData: [],
  exportDataDetail: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listExportDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_EXPORT_DATA_REQUEST:
      return { ...state, loading: true }
    case LIST_EXPORT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        exportData: action.payload,
        pageable: action.pageable
      }
    case LIST_EXPORT_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        exportData: action?.dummy
      }
    case LIST_EXPORT_DATA_RESET:
      return {
        ...state,
        loading: false,
        exportData: [],
        pageable: {
          page: 1,
          size: 10
        }
      }
    case DOWNLOAD_EXPORT_DATA_REQUEST:
      return { ...state, loadingExportDataDownload: true }
    case DOWNLOAD_EXPORT_DATA_SUCCESS:
      return {
        ...state,
        loadingExportDataDownload: false,
        exportDataDetail: action.payload,
        pageable: state.pageable
      }
    case DOWNLOAD_EXPORT_DATA_FAIL:
      return {
        ...state,
        loadingExportDataDownload: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default listExportDataReducer
